import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "circle-half-filled-16", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("path", { d: "M8 1a7 7 0 110 14A7 7 0 018 1zm0 1.5v11a5.5 5.5 0 000-11z", fill: "currentColor" }));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
